// src/modals/CsvShineModal.jsx — modale d'import CSV Shine (banque pro).
// Permet de prévisualiser les transactions parsées, choisir leur catégorie
// (charge fixe / consommable / dépense variable / ignorer) et tagger un
// logement pour les variables/consommables.

import { useState } from "react"
import { Settings, Package, BarChart3, Ban, Check } from "lucide-react"
import { DS } from "../lib/ui"

import useEchapPourFermer from "../lib/useEchapPourFermer"
export default function CsvShineModal({ rows, cfg, mk, onImport, onClose }) {
  // Échap ferme — consigne 2026-08-14, hook partagé (pile anti-double-fermeture).
  useEchapPourFermer(onClose)

  const [items, setItems] = useState(rows.map(r => ({ ...r, selected: true })))
  const allLogs = cfg.props.flatMap(p => p.logs.map(l => ({ ...l, propNom: p.nom })))
  const CAT_LABELS = { fixe: "Charge fixe", consommable: "Consommable", variable: "Dépense variable", ignore: "Ignorer" }
  const CAT_ICONS = { fixe: Settings, consommable: Package, variable: BarChart3, ignore: Ban }
  const CAT_COLORS = { fixe: DS.marine, consommable: DS.success, variable: DS.charge, ignore: DS.textMuted }

  const update = (i, key, val) => setItems(prev => prev.map((item, idx) => idx === i ? { ...item, [key]: val } : item))

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:1001,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div className="fbz-modal-sheet" style={{background:DS.card,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:600,maxHeight:"90vh",display:"flex",flexDirection:"column",fontFamily:DS.fontBody}}>
        {/* Header */}
        <div style={{padding:"18px 20px",borderBottom:`1px solid ${DS.border}`,flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{fontFamily:DS.fontDisplay,fontWeight:600,color:DS.marineDark,fontSize:17}}>Import CSV Shine</div>
            <button onClick={onClose} style={{background:"none",border:"none",fontSize:24,cursor:"pointer",color:DS.textMuted}}>×</button>
          </div>
          <div style={{fontSize:11,color:DS.textMuted,marginTop:4}}>{items.filter(i => i.selected).length} transaction(s) sélectionnée(s) · Vérifiez les catégories avant import</div>
        </div>

        {/* Liste transactions */}
        <div style={{overflowY:"auto",flex:1,padding:"12px 16px"}}>
          {items.map((item, i) => (
            <div key={item.id} style={{borderBottom:`1px solid ${DS.border}`,paddingBottom:10,marginBottom:10}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
                <input type="checkbox" checked={item.selected} onChange={e => update(i, "selected", e.target.checked)} style={{width:15,height:15,cursor:"pointer"}}/>
                <div style={{flex:1}}>
                  <div style={{fontSize:12,fontWeight:600,color:DS.textPrimary}}>{item.libelle}</div>
                  <div style={{fontSize:10,color:DS.textMuted}}>{item.date}</div>
                </div>
                <div style={{fontFamily:DS.fontDisplay,fontSize:14,fontWeight:600,color:DS.charge}}>{item.montant.toFixed(2)} €</div>
              </div>
              {item.selected && (
                <div style={{display:"flex",gap:6,flexWrap:"wrap",paddingLeft:24}}>
                  {/* Catégorie */}
                  <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                    {Object.entries(CAT_LABELS).map(([cat, label]) => {
                      const Ico = CAT_ICONS[cat]
                      const on = item.cat===cat
                      return (
                      <button key={cat} className="fbz-press" onClick={() => update(i, "cat", cat)}
                        style={{display:"inline-flex",alignItems:"center",gap:4,padding:"3px 8px",border:`1.5px solid ${on?CAT_COLORS[cat]:DS.border}`,borderRadius:7,background:on?CAT_COLORS[cat]+"15":DS.card,color:on?CAT_COLORS[cat]:DS.textMuted,fontWeight:on?700:400,fontSize:10,cursor:"pointer",fontFamily:DS.fontBody}}>
                        <Ico size={12} strokeWidth={2}/> {label}
                      </button>
                    )})}
                  </div>
                  {/* Logement (si variable ou consommable) */}
                  {(item.cat === 'variable' || item.cat === 'consommable') && (
                    <select value={item.logId || ""} onChange={e => update(i, "logId", e.target.value)}
                      style={{border:`0.5px solid ${DS.borderHover}`,borderRadius:7,padding:"3px 8px",fontSize:10,outline:"none",background:DS.card,fontFamily:DS.fontBody}}>
                      <option value="">Global</option>
                      {allLogs.map(l => <option key={l.id} value={l.id}>{l.nom.split(" ").slice(0, 3).join(" ")}</option>)}
                    </select>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{padding:"14px 20px",borderTop:`1px solid ${DS.border}`,flexShrink:0,display:"flex",gap:8}}>
          <button className="fbz-press" onClick={onClose} style={{flex:1,padding:12,background:DS.card,color:DS.marine,border:`0.5px solid ${DS.borderHover}`,borderRadius:DS.radiusControl,fontWeight:600,cursor:"pointer",fontFamily:DS.fontBody}}>Annuler</button>
          <button className="fbz-press" onClick={() => onImport(items.filter(i => i.selected && i.cat !== "ignore"))}
            style={{flex:2,display:"inline-flex",alignItems:"center",justifyContent:"center",gap:7,padding:12,background:DS.corail,color:"#fff",border:"none",borderRadius:DS.radiusControl,fontWeight:700,cursor:"pointer",fontFamily:DS.fontBody}}>
            <Check size={16} strokeWidth={2.4}/> Importer {items.filter(i => i.selected && i.cat !== "ignore").length} transaction(s)
          </button>
        </div>
      </div>
    </div>
  )
}
